const ContractStatuses = [
    {id: "NEW", name: "НОВА"},
    {id: "IN_PROCESS", name: "ОБРОБЛЯЄТЬСЯ"},
    {id: "APPROVED", name: "ПІДТВЕРДЖЕНА"},
    {id: "DECLINED", name: "ВІДМІНЕНА"},
    {id: "PENDING_NHS_SIGN", name: "ОЧІКУЄ НА ПІДПИСАННЯ ВІД НСЗУ"},
    {id: "NHS_SIGNED", name: "ПІДПИСАНА НСЗУ"},
    {id: "TERMINATED", name: "ЗАВЕРШЕНИЙ"},
    {id: "SIGNED", name: "ПІДПИСАНА"},
    {id: "VERIFIED", name: "Верифіковано зі сторони НСЗУ"},
];

export default ContractStatuses;